export enum AppContextEnum {
  SIGN = "sign",
  THG = "thg",
  THG_PORTAL = "thgPortal",
  REPORT = "report",
  REPORT_PORTAL = "reportPortal",
  DOCPHANT = "docphant"
}
